/*global jQuery, RapidInstance*/
(function ($) {
    'use strict';

    /**
     * Enables top videos Rapid Tracking. To be used in conjunction with TopVideo.
     */
    $.fn.topVideosTracking = function (option/*, varArgs*/) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function () {
            var $element = $(this);
            var ctrl = $element.data('topVideosTracking');

            if (!ctrl) {
                $element.data('topVideosTracking', (ctrl = new TopVideosTracking(this)));
            }

            if (typeof option === 'string') {
                ctrl[option].apply(ctrl, args);
            }
        });
    };

    function TopVideosTracking(element) {
        this.init(element);
    }

    TopVideosTracking.prototype = {
        constructor: TopVideosTracking,

        // Properties
        $videosList: null,

        // Methods
        /**
         * @private
         * @param {jQuery} element
         */
        init: function (element) {
            this.$element = $(element);
            this.$videosList = this.$element.find('.top-videos__list__content');

            this.$element.on('autoPlayFirst', this.autoPlayFirst.bind(this));
            this.$element.on('cardClick',     this.cardLinkClick.bind(this));
            this.$element.on('clickPlay',     this.afterClick.bind(this));
            this.$element.on('autoPlay',      this.autoPlayNext.bind(this));
        },

        autoPlayFirst: function (event, videoUrl) {
            console.log('Top Videos - auto play first:', videoUrl);

            if (window.RapidInstance) {
                window.RapidInstance.beaconEvent('simple', {
                    _R: videoUrl,
                    expn: 'autoplay-first',
                    navtype: 'client'
                }, 'top-videos');
            }
        },

        afterClick: function (event, videoUrl) {
            console.log('Top Videos - after click:', videoUrl);

            if (window.RapidInstance) {
                window.RapidInstance.beaconEvent('simple', {
                    _R: videoUrl,
                    expn: 'click-play',
                    navtype: 'client'
                }, 'top-videos');
            }
        },

        autoPlayNext: function (event, videoUrl) {
            console.log('Top Videos - auto play next:', videoUrl);

            if (window.RapidInstance) {
                window.RapidInstance.beaconEvent('simple', {
                    _R: videoUrl,
                    expn: 'auto-play',
                    navtype: 'client'
                }, 'top-videos');
            }
        },

        /**
         * Top video card (thumb) was clicked.
         * @param {Event} event
         * @param {HTMLElement} linkEl
         */
        cardLinkClick: function (event, linkEl) {
            var $link = $(linkEl);
            var $card = $link.closest('.card');
            var pValue = this.$cards.index($card);
            var $rapidSec = this.$element.closest('[data-rapid-sec]');
            var rapidSec, secData;

            if ($rapidSec.length) {
                try {
                    secData = JSON.parse($rapidSec.attr('data-rapid-sec'));
                } catch (e) {
                    secData = null;
                }

                if (secData) {
                    // Extract the rapid section key
                    for (var key in secData) {
                        if (secData.hasOwnProperty(key)) {
                            rapidSec = key;
                            break;
                        }
                    }
                }
            }

            if (window.RapidInstance) {
                window.RapidInstance.beaconClick(
                    rapidSec, $link.text(), pValue, {
                        sub_sec: 'top-videos', cpos: pValue, pos: 1
                    }
                );
            }
        },

        get $cards() {
            return this.$videosList.find('.card');
        }
    };

    $('.top-videos').topVideosTracking();
})(jQuery);
